import { THERMOCOUPLE_STATE } from '../components/CycleTable/constants';
import { ChannelState } from '../enums/channel-state.enum';
import { channelStateToEnum } from './value-to-enum';

const getValidCycleState = (state: number): ChannelState | number => {
  return typeof state === 'number' ? channelStateToEnum(state) : THERMOCOUPLE_STATE;
};

export default getValidCycleState;
